document.addEventListener("click", async function(e) {

  const button = e.target.closest(".zyvor-card-atc-btn");

  if (!button) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = button.dataset.variantId;

  if (!variantId) return;

  button.disabled = true;
  button.innerText = "Adding...";

  try {

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    });

    if (!response.ok) throw new Error();

    button.innerText = "Added ✓";

    setTimeout(() => {
      button.innerText = "Add to Cart";
      button.disabled = false;
    }, 1500);

  } catch {

    button.innerText = "Error";

    setTimeout(() => {
      button.innerText = "Add to Cart";
      button.disabled = false;
    }, 1500);

  }

}, true);